import { render, staticRenderFns } from "./USubHeader.vue?vue&type=template&id=54a36b6c&"
import script from "./USubHeader.vue?vue&type=script&lang=js&"
export * from "./USubHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports